import type { SystemkeyModel } from '@/shared/types'
import http from '../01_axios'
import type { ApiResponse } from '../01_axios/api/response.api'
import { apiGetSystemKey } from './components/urls'

const getSystemKey = (): Promise<ApiResponse<SystemkeyModel[]>> => http.get(apiGetSystemKey)

const systemkeyService = { getSystemKey }
export default systemkeyService
